import { Divider, Typography } from '@mui/material'
import React from 'react'
import { galleryActions } from '../actions';
import { useDispatch } from 'react-redux';


const styles = {
    divider: {
        marginBottom: "10px"
    },
    img: { cursor:"pointer" }
}

const Promociones = ({ images }) => {
    const dispatch = useDispatch()

    const changeCategoria = (categoria = "") => {
        dispatch(galleryActions.setSearchTerm(""));
        dispatch(galleryActions.setCategoria(""));
        dispatch(galleryActions.setRubro(""));
        dispatch(galleryActions.setSubRubro(""));
        dispatch(galleryActions.setPromocion(categoria));
      };
   

    return images.map((img, i) => (
        <div key={`${img}-${i}`}>
            <Typography align="center">
                {img.label}
            </Typography>
            <Divider sx={styles.divider} />
            <img src={img.imgPath} alt={`${img.label}`} style={styles.img} onClick={() => changeCategoria(img.label) } />
        </div>
    ))

}

export default Promociones